// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__23mDA","rootSmall":"AddTileButton_rootSmall__3MDlJ"};